import React, { useContext, useState, useEffect, useRef } from "react";
import ActionImage from "../../Assets/Images/action.png";
import BellIcon from "../../Assets/Images/BellIcon.svg";
import MessageIcon from "../../Assets/Images/MessageIcon.svg";
import deleteicon from "../../Assets/Images/DeleteIcon.svg";
import refreshmanicon from "../../Assets/Images/refreshManIcon.svg";
import SelfImage from "../../Assets/Images/Self.svg";
import copyicon from "../../Assets/Images/copyIcon.svg";
import moreoptionicon from "../../Assets/Images/moreOptionIcon.svg";
import successicon from "../../Assets/Images/successIcon.svg";
import Box from "../../Assets/Images/box (3).png";
import Checkbox from "../../Assets/Images/checkbox.png";
import AuthContext from "../../Context/AuthContext";
import { dashboardStyle } from "../htmlRender/htmlDashboard";
import {
  deleteAssessment,
  fetchTokens,
  updateAssessmentStatus,
  fetchDeployments,
  fetchAssessments,
  updateTokens,
  checkTeamNameExists,
  createTeamName,
  fetchPreviewData,
  generateSelfReport,
  sendNotifications,
  fetchVariables,
} from "../../api";
import { toast } from "react-toastify";
import { TailSpin } from "react-loader-spinner";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { TokenContext } from "../../Context/TokenContext";
import { Modal, Typography, Button, CircularProgress } from "@mui/material";
import Success from "../../Assets/Images/success.svg";
import deleteIcon from "../../Assets/Images/deleteIcon.png";
import GroupReportContext from "../../Context/GroupReportContext";
import infoIcon from "../../Assets/Images/vectorImg.png";
import EditIcon from "../../Assets/Images/editicon.svg";
import { AssessmentContext } from "../../Context/AssessmentContext";
import { authenticatedFetch } from "../../utils/apiUtils";

//input data
const statusColorMap = {
  complete: "#73B76F",
  inactive: "#E1E1E1",
  active: "#B6111F",
  pending: "#EEC146",
};

const statusColor = {
  complete: "#FFFFFF",
  inactive: "#7D7D7D",
  active: "#FFFFFF",
  pending: "#FFFFFF",
};

const statusTextMap = {
  complete: "Done",
  inactive: "Inactive",
  active: "Yet to Start",
  pending: "Ongoing",
};

export default function AssessmentList(props) {
  // State for self-report generation loading
  const [isGeneratingSelfReport, setIsGeneratingSelfReport] = useState({});
  //props
  const {
    selectedMembers,
    setSelectedMembers,
    setValue,
    clientId,
    isLoading,
    assessmentList,
    setAssessmentList,
    refreshAssessments,
    editForm,
    setEditForm,
    updateClientData,
    clientData,
  } = props;

  //useNavigates and Context
  const navigate = useNavigate();
  const tokenCtx = useContext(TokenContext);
  const authCtx = useContext(AuthContext);
  const asmtCtx = useContext(AssessmentContext);
  const orgId = authCtx.orgId;
  const { useGroupReport, addGroupReport, setOpenReport, setSelectedReport, selectedReportType, setSelectedReportType, setGroupMembersHashMap } = useContext(GroupReportContext);

  //searchParams
  const [searchParams, setSearchParams] = useSearchParams();
  const { id: deploymentID } = useParams();

  // State for modals
  const [showObserverCountModal, setShowObserverCountModal] = useState(false);
  const [showSelfAssessmentAlert, setShowSelfAssessmentAlert] = useState(false);
  const [previewApiData, setPreviewApiData] = useState([])
  const [reportInfo, setReportInfo] = useState()
  const [isGeneratingReport, setIsGeneratingReport] = useState(false)

  // Call preview API on component mount
  const callPreviewApi = async () => {
    try {
      if (clientId) {
        let previewData = await fetchPreviewData(clientId);
        setPreviewApiData(previewData.data);
      }
    } catch (error) { }
  };

  //useState
  const [showMoreOptions, setShowMoreOptions] = useState(
    Array(assessmentList.length).fill(false)
  );
  const [moreDetail, setMoreDetail] = useState([]);
  const [tokenBuy, setTokenBuy] = useState(true);
  const [checkboxStates, setCheckboxStates] = useState(Array(10).fill(false));
  const [downloading, setDownloading] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  const [tokenBuyStates, setTokenBuyStates] = useState({});
  const [successStates, setSuccessStates] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [deleteIndexes, setDeleteIndexes] = useState({
    outerIndex: null,
    innerIndex: null,
  });
  const componentRef = useRef(null);
  const [activateButtonStatus, setActivateButtonStatus] = useState(null);
  const [assessmentType, setAssessmentType] = useState("");
  const domainName = process.env.REACT_APP_DOMAIN
  const [asmtLink, setAsmtLink] = useState(domainName);
  const [selectedAssessmentId, setSelectedAssessmentId] = useState(null);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [purchasingAssessmentHash, setPurchasingAssessmentHash] = useState(null);
  const [processedPayment, setProcessedPayment] = useState(false);
  const [teamName, setTeamName] = useState("");
  const [teamNameError, setTeamNameError] = useState("");
  const [showEmail, setShowEmail] = useState(0);
  const [openedTab, setOpenedTab] = useState(0);
  const [isValidatingTeamName, setIsValidatingTeamName] = useState(false);
  const [teamNameExists, setTeamNameExists] = useState(false);
  const [isGeneratingGroupReport, setIsGeneratingGroupReport] = useState(false);
  const [isAutoGeneratedName, setIsAutoGeneratedName] = useState(true);
  const [memebersReport, setMemebersReport] = useState([]);
  const [memebersSelf, setMemebersSelf] = useState();
  const [membersReportTeamName, setMembersReportTeamName] = useState();
  const [asmtAlertText, setAsmtAlertText] = useState("");
  const [is360ReportGenerating, setIs360ReportGenerating] = useState(false);

  // ─────────────────────────────────────────────────────────────────────────────
  // Helpers: reliable checks for existing reports (preview API) + filenames
  // ─────────────────────────────────────────────────────────────────────────────
  const sanitizeName = (str = "") => str.replace(/\s+/g, "").trim();

  const hasExistingSelfReport = (hash) => {
    if (!previewApiData?.length) return false;
    return previewApiData.some(
      (t) =>
        (t?.type || "").toLowerCase() === "self" &&
        Array.isArray(t.results) &&
        t.results.some((r) => r?.hash === hash)
    );
  };

  const checkReportExist = (assessmentHash, type) => {
    const reportExists = reportInfo.find((el) => el.hash == assessmentHash && el.type == type)
    const selfReportExists = reportInfo.find((el) => el.results?.[0]?.hash == assessmentHash && el.type == type)

    // console.log("reportInfo",reportInfo)
    if (reportExists || selfReportExists) {
      return true
    }

    return false
  };

  const nextUniqueNameFor360 = (baseName) => {
    if (!previewApiData?.length) return baseName;
    const cleanBase = sanitizeName(baseName);

    const rx = new RegExp(
      `^${cleanBase?.replace(/[.*+?^${}()|[\\]\\\\]/g, "\\$&")}(?:\\s\\((\\d+)\\))?$`
    );
    const nums = previewApiData
      .filter(
        (t) => (t?.type || "").toLowerCase() === "360" && rx.test(sanitizeName(t?.filename || ""))
      )
      .map((t) => {
        const m = (t.filename || "").match(rx);
        return m && m[1] ? parseInt(m[1], 10) : 0;
      });
    if (nums.length === 0) return baseName;
    const max = Math.max(...nums);
    return `${baseName} (${max + 1})`;
  };
  // ─────────────────────────────────────────────────────────────────────────────

  let allSelf = assessmentList
    ?.map((el) => {
      if (el?.designation === "Self-Assessment" && el.status === "complete") {
        return el?.assessment_hash;
      } else if (el?.designation === "360 Assessment") {
        const selfIn360 = el?.members?.find(
          (el) => el.designation === "Self-Assessment" && el.status === "complete"
        );
        return selfIn360?.assessment_hash;
      }
      return null;
    })
    .filter(Boolean);

  function arraysMatchIgnoringOrder(selectedMembers, allSelf) {
    if (selectedMembers?.length === 0) return false; // keep unchecked when empty
    return selectedMembers.length === allSelf.length && selectedMembers.every((item) => allSelf.includes(item))
    
  }

  const arraysMatch = arraysMatchIgnoringOrder(selectedMembers, allSelf);


  const generateNextTeamName = async () => {
    try {
      const existingTeams = await checkTeamNameExists(clientId);

      if (
        existingTeams?.status === "success" &&
        existingTeams?.data &&
        Array.isArray(existingTeams.data)
      ) {
        const teamNumbers = existingTeams.data
          .map((team) => team.teamname)
          .filter((name) => name && /^Team \d+$/i.test(name))
          .map((name) => parseInt(name.replace(/^Team /i, "")))
          .filter((num) => !isNaN(num))
          .sort((a, b) => a - b);

        let nextNumber = 1;
        for (const num of teamNumbers) {
          if (num === nextNumber) {
            nextNumber++;
          } else {
            break;
          }
        }

        return `Team ${nextNumber}`;
      }

      return "Team 1";
    } catch (error) {
      return "Team 1";
    }
  };

  // NOTE: signature updated to accept optional filenameOverride
  const generate360Report = async (selfAssessment, filenameOverride) => {
    setSuccessStates({});
    setIs360ReportGenerating(true);

    try {
      const observerCount =
        selectedMembers?.filter((id) => id !== memebersSelf?.assessment_hash)
          .length || 0;

      if (observerCount < 3) {
        setShowObserverCountModal(true);
        return;
      }

      if (!selectedMembers?.includes(memebersSelf?.assessment_hash)) {
        setAsmtAlertText("Please select the Self-Assessment to generate your 360 Report.");
        setShowSelfAssessmentAlert(true);
        return;
      }

      const baseName = `${selfAssessment?.userName || "User"} - 360 Report`.trim();
      const reportName = filenameOverride || nextUniqueNameFor360(baseName);

      const createTeamResponse = await createTeamName({
        deploymentId: clientId,
        filename: reportName,
        members: memebersReport,
        type: "360",
        teamname: reportName,
      });

      if (createTeamResponse?.status === "success") {
        toast.success("You're all set! Your 360 Report is ready.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });

        navigate(`/client/${clientId}?tab=reports&reportType=360`);
        setValue && setValue(2);
      } else {
        toast.error("Failed to generate 360 Report. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while generating the 360 Report.");
    } finally {
      setIs360ReportGenerating(false);
      await callPreviewApi(); // refresh preview so UI flips to View
      window.dispatchEvent(new CustomEvent('groupReportPreviewDataUpdated'));
    }
  };

  const createSelfReport = async (selfAssessment, filenameOverride) => {
    setIsGeneratingReport(true)
    setOpenReport(true);
    setSuccessStates({});
    setIsGeneratingSelfReport(prev => ({ ...prev, [selfAssessment.assessment_hash]: true }));

    const reportName = selfAssessment?.userName

    const payload = {
      deploymentId: clientId,
      filename: reportName,
      members: [selfAssessment?.assessment_hash],
      type: "Self",
      teamname: reportName,
    }

    // console.log("Creating self report with payload:", payload);

    try {
      const createTeamResponse = await createTeamName(payload);
      // console.log("createTeamResponse:", createTeamResponse);

      if (createTeamResponse?.status === "success") {
        toast.success("You're all set! Your Self Report is ready.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });

        navigate(`/client/${clientId}?tab=2`);
        setValue && setValue(2);
      }
      else {
        // console.error("Self report generation failed. Response:", createTeamResponse);
        toast.error(`Failed to generate Self Report: ${createTeamResponse?.message || 'Unknown error'}`);
      }
    } catch (error) {
      // console.error("Error in createSelfReport:", error);
      toast.error(`An error occurred while generating the Self Report: ${error.message}`);
    } finally {
      setIsGeneratingReport(false)
      setIsGeneratingSelfReport(prev => ({ ...prev, [selfAssessment.assessment_hash]: false }));
      await callPreviewApi(); // refresh preview so UI flips to View
      window.dispatchEvent(new CustomEvent('groupReportPreviewDataUpdated'));
    }
  };

  const finalHTML = `
  <!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta http-equiv="X-UA-Compatible" content="ie=edge">
      <title>HTML 5 Boilerplate</title>
      ${dashboardStyle}
    </head>
    <body>
    <main class="main">
    ${htmlContent}
    </main>
    </body>
  </html>
  `;
  //functions
  // const updateClientData = async () => {
  //   try {
  //     const clientData = await fetchDeployments(authCtx);
  //     const currentClient = clientData.find(c => c.id == clientId);
  //     if (currentClient) {
  //       let assessments = await fetchAssessments(currentClient.id);

  //       const enrichedAssessments = assessments?.map(element => {
  //         const clonedElement = { ...element };
  //         clonedElement.members = clonedElement.members ? [...clonedElement.members] : [];

  //         if (clonedElement?.designation === "360 Assessment") {
  //           const alreadyHasSelfAssessment = clonedElement.members.some(
  //             m => m.designation === "Self-Assessment"
  //           );

  //           if (!alreadyHasSelfAssessment) {
  //             const respondentSelfAssessment = {
  //               ...clonedElement,
  //               designation: "Self-Assessment",
  //               isLinkedTo360: true,
  //             };
  //             clonedElement.members.push(respondentSelfAssessment);
  //           }
  //         }

  //         return clonedElement;
  //       });

  //       const completeAssessments = enrichedAssessments.filter(a => a.status === "complete");

  //       const updatedClient = {
  //         ...currentClient,
  //         totalAssessments: enrichedAssessments?.length || 0,
  //         completeAssessments: completeAssessments.length,
  //         pendingAssessment: (enrichedAssessments?.length || 0) - completeAssessments.length,
  //         assessments: enrichedAssessments,
  //       };
  //       // setAssessmentList(enrichedAssessments);
  //       localStorage.setItem("clientData", JSON.stringify(updatedClient));
  //       return updatedClient;
  //     }
  //   } catch (error) {
  //     // console.error('Error updating client data:', error);
  //   }
  // };

  const handleOpenModal = (assessment_hash) => {
    setSuccessStates({});
    setSelectedAssessmentId(assessment_hash);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedAssessmentId(null);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await deleteAssessment({
        assessmentId: selectedAssessmentId,
        deploymentId: clientId,
      });

      if (response.status === "success") {
        toast.success("Assessment deleted successfully!");
        setAssessmentList(
          assessmentList.filter((f) => f.assessment_hash !== selectedAssessmentId)
        );
        updateClientData();
        setSelectedAssessmentId(null);
      } else {
        toast.error("Unable to delete assessment!");
      }
    } catch (error) {
      toast.error("Unable to delete assessment!");
    } finally {
      setOpenModal(false);
      window.dispatchEvent(new CustomEvent('groupReportPreviewDataUpdated'));
    }
  };

  const handleGenerateGroupReport = async () => {
    if (!teamName.trim()) {
      setTeamNameError("Please enter the team name to be displayed in the Group Report.");
      return;
    }

    if (selectedMembers?.length > 30) {
      toast.error("You can select up to 30 members per group report.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return
    }

    const isTeamNameValid = await validateTeamName(teamName);
    if (!isTeamNameValid) return;

    setIsGeneratingGroupReport(true);

    try {
      const selectedAssessmentDetails = assessmentList.reduce(
        (acc, item, index) => {
          if (selectedMembers.includes(item.assessment_hash)) {
            acc.push({
              assessment_hash: item.assessment_hash,
              userName: item.userName,
              designation: item.designation,
              status: item.status,
              email: item.email,
              orgType: item.orgType,
              members: item.members,
              completeDate: item.completeDate,
              data: item,
            });
          }

          item.members?.forEach((member, subIndex) => {
            if (selectedMembers.includes(`${index + 1}.${subIndex + 1}`)) {
              acc.push({
                assessment_hash: member.assessment_hash,
                userName: member.userName,
                designation: member.designation,
                status: member.status,
                email: member.email,
                orgType: member.orgType,
                completeDate: member.completeDate,
                data: member,
              });
            }
          });
          return acc;
        },
        []
      );

      const allComplete = selectedAssessmentDetails.every(
        (item) => item.status !== "inactive"
      );
      if (!allComplete) {
        toast.error(
          "Complete all selected assessments to generate the Group Report."
        );
        return;
      }

      const teamMembers = selectedAssessmentDetails.map(
        (assessment) => assessment.assessment_hash
      );

      const createTeamResponse = await createTeamName({
        deploymentId: clientId,
        filename: "team_config.json",
        members: teamMembers,
        type: "group",
        teamname: teamName,
      });

      if (createTeamResponse?.status === "success") {
        let companyName = localStorage.getItem("clientData");
        companyName = JSON.parse(companyName)?.company || "";

        const availableTokens = tokenCtx.selectedToken || 0;
        if (availableTokens >= 4) {
          await updateTokens({
            orgId: localStorage.getItem("orgId"),
            token: availableTokens - 4,
          });
          tokenCtx.setSelectedToken(prev => prev - 4);
        }

        // addGroupReport(companyName, selectedAssessmentDetails, teamName);

        setValue && setValue(2);
        toast.success("Group report generated successfully!");
      } else {
        toast.error("Failed to create team name. Please try again.");
      }
    } catch (error) {
      toast.error("Failed to generate group report. Please try again.");
    } finally {
      setIsGeneratingGroupReport(false);
      await callPreviewApi();
      window.dispatchEvent(new CustomEvent('groupReportPreviewDataUpdated'));
    }
  };

  const validateTeamName = async (teamName) => {
    if (!teamName.trim()) {
      setTeamNameError("Team name is required");
      setTeamNameExists(false);
      return false;
    }

    setIsValidatingTeamName(true);
    setTeamNameError("");

    try {
      const existingTeams = await checkTeamNameExists(clientId);

      if (
        existingTeams?.status === "success" &&
        existingTeams?.data &&
        Array.isArray(existingTeams.data)
      ) {
        const teamExists = existingTeams.data.some(
          (team) =>
            team.teamname &&
            team.teamname.toLowerCase() === teamName.toLowerCase()
        );

        if (teamExists) {
          setTeamNameError(
            "Team name already exists. Please choose a different name."
          );
          setTeamNameExists(true);
          setIsValidatingTeamName(false);
          return false;
        }
      }

      setTeamNameExists(false);
      setIsValidatingTeamName(false);
      return true;
    } catch (error) {
      setTeamNameError("Error validating team name. Please try again.");
      setTeamNameExists(false);
      setIsValidatingTeamName(false);
      return false;
    }
  };

  const handleCopy = (url, showDisabled) => {
    setSuccessStates({});

    if (showDisabled) {
      const toastId = "link-copy-toast";
      if (!toast.isActive(toastId)) {
        toast.info("Please activate your assessment!", { toastId });
      } else {
        toast.update(toastId, { render: "Please activate your assessment!" });
      }
      return;
    }

    navigator.clipboard
      .writeText(url)
      .then(() => {
        const toastId = "link-copy-toast";
        if (!toast.isActive(toastId)) {
          toast.success("Link copied to clipboard!", { toastId });
        } else {
          toast.update(toastId, { render: "Link copied to clipboard!" });
        }
      })
      .catch((err) => {
        toast.error("Failed to copy the link.");
      });
  };

  const handleTokenPurchase = async (assessmentId, designation, assessment) => {
    setPurchasingAssessmentHash(assessmentId);
    const availableTokens = tokenCtx.selectedToken || 0;
    const requiredTokens = designation?.includes("Self") ? 2 : 4;

    if (availableTokens < requiredTokens) {
      toast.error(
        "Insufficient tokens. Please purchase more tokens to continue.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
      navigate(`/tokens?clientId=${clientId}`, {
        state: { requiredTokens },
      });
      setPurchasingAssessmentHash(null);
      return;
    }

    const remainingTokens = availableTokens - requiredTokens;
    tokenCtx.setSelectedToken(remainingTokens);
    await fetchTokens({
      orgId: localStorage.getItem("orgId"),
      token: remainingTokens,
    });

    await handleStatusUpdate({
      assessmentId: assessmentId,
      deploymentId: clientId,
      status: "active",
      designation,
    });

    setTokenBuyStates((prev) => ({
      ...prev,
      [`${assessmentId}_${designation}`]: false,
      [`${assessmentId}_Self`]: false,
    }));

    setSuccessStates((prev) => ({
      ...prev,
      [`${assessmentId}_${designation}`]: true,
      [`${assessmentId}_Self`]: true,
    }));

    const reportLink = `/client/${clientId}?tab=reports&assessmentId=${assessmentId}`;
    const isSelf = designation?.includes("Self");
    const capitalizeWords = (str) => {
      return str?.replace(/\b\w/g, (char) => char.toUpperCase()) || "";
    };
    const capitalizedUserName = capitalizeWords(assessment.userName);

    if (isSelf) {
      await sendNotifications({
        action: "go_to_clients",
        action_link: reportLink,
        msg: `An email has been sent to <strong>${capitalizedUserName}</strong> with their Self-Assessment link. You can also copy and share the link manually if needed.`,
        user_name: assessment.userName || "User",
        type: "activate_self_asmt",
        orgId: orgId,
        asmtId: assessment.assessment_hash,
        clientId: clientId,
      });
    } else {
      await sendNotifications({
        action: "go_to_clients",
        action_link: reportLink,
        msg: `An email has been sent to <strong>${capitalizedUserName}</strong> with their Self-Assessment link. You can also copy and share the link manually if needed.`,
        user_name: assessment.userName || "User",
        type: "activate_respondent",
        orgId: orgId,
        asmtId: assessmentId,
        clientId: clientId,
      });

      if (Array.isArray(assessment.members) && assessment.members.length > 0) {
        await sendNotifications({
          action: "go_to_clients",
          action_link: reportLink,
          msg: `Invitation emails have been sent to <strong>${capitalizedUserName}</strong>’s selected observers. You can also copy and share the links manually if needed.`,
          user_name: assessment.userName || "Respondent",
          type: "activate_observer",
          orgId: orgId,
          asmtId: assessmentId,
          clientId: clientId,
        });
      }
    }

    // setShowSuccessMessage(prev => ({
    //   ...prev,
    //   [assessmentId]: true
    // }));

    // setTimeout(() => {
    //   setShowSuccessMessage(prev => ({
    //     ...prev,
    //     [assessmentId]: false
    //   }));
    // }, 10000);
    // await handleStatusUpdate({
    //   assessmentId: assessmentId,
    //   deploymentId: clientId,
    //   status: "active",
    // })

    if (Array.isArray(assessment?.members) && assessment.members.length > 0) {
      const updatedMembers = assessment.members
        .filter((member) => member.assessment_hash !== assessmentId)
        .map((member) =>
          handleStatusUpdate({
            assessmentId: member.assessment_hash,
            deploymentId: clientId,
            status: "active",
            designation: member.designation,
          })
        );

      await Promise.all(updatedMembers);
    }

    setPurchasingAssessmentHash(null);
    // toast.success('Assessment purchased successfully!', {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    //   theme: "light",
    // });
  };

  const handleStatusUpdate = async ({
    assessmentId,
    deploymentId,
    status,
    designation,
  }) => {
    const availableTokens = tokenCtx.selectedToken || 0;
    const requiredTokens = designation?.includes("Self") ? 2 : 4;

    try {
      const response = await updateAssessmentStatus({
        assessmentId: assessmentId,
        deploymentId: deploymentId,
        status: status,
      });

      if (response?.status === "success") {
        const remainingTokens = availableTokens - requiredTokens;
        const orgId = localStorage.getItem("orgId");

        await updateTokens({
          orgId: orgId,
          token: remainingTokens,
        });

        if (designation == "Self-Assessment") {
          toast.success(`Assessment activated successfully!`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (designation == "360 Assessment") {
          toast.success(`360 Assessment activated successfully!`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }

        const prevMoreDetail = [...moreDetail];
        updateClientData();
        setMoreDetail(prevMoreDetail);
      } else {
        toast.error(`Error activating the assessment`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (error) { }
  };

  const handleMoreOptionsToggle = (index) => {
    const updatedVisibility = [...showMoreOptions];
    updatedVisibility[index] = !updatedVisibility[index];
    setShowMoreOptions(updatedVisibility);
    setSuccessStates({});

    if (!showMoreOptions[index]) {
      const currentItem = assessmentList[index];
      if (currentItem?.members) {
        // const observerIndexes = currentItem.members
        //   .slice(0, 3)
        //   .map((_, subIndex) => `${index + 1}.${subIndex + 1}`);
        // setSelectedMembers(prev => {
        //   // console.log("prev", prev);
        //   const existing = prev.filter(id => typeof id === 'string' && !id.includes('.'));
        //   return [...existing, ...observerIndexes];
        // });
      }
    }
  };

  const handleMoreDetail = (id, designation) => {
    if (designation?.includes("Self") && successStates[`${id}_Self`]) return;
    if (designation?.includes("360") && successStates[`${id}_360`]) return;

    setSuccessStates({});

    setMoreDetail((prevDetail) =>
      prevDetail?.includes(id)
        ? prevDetail.filter((memberId) => memberId !== id)
        : [...prevDetail, id]
    );
  };

  const onDownloadPDF = async (selectedIds) => {
    setDownloading(true);
    try {
      if (typeof selectedIds === "string") {
        const response = await fetch(
          process.env.REACT_APP_API_URI +
          "/v3/admin/assessment/" +
          selectedIds +
          "/generateReport",
          {
            method: "POST",
            headers: {
              "Content-Type": "text/html",
              Authorization: authCtx.token,
            },
            body: finalHTML.replaceAll(
              "https://studentassessment.trellischurches.com/static/media/pulse.142103272f0441d3c0a514291ad53281.svg",
              "https://studentassessment.trellischurches.com/static/media/minus.445c6eadd1460c78c5382a1087a951d9.svg"
            ),
          }
        );

        const url = await response.json();
        const pdfUrl = await url.reportURL;

        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "Result.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        const selectedAssessments = assessmentList.filter(
          (item, index) =>
            selectedIds.includes(index) || selectedIds.includes(`${index + 1}`)
        );

        const response = await fetch(
          process.env.REACT_APP_API_URI +
          "/v3/admin/assessment/generateGroupReport",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: authCtx.token,
            },
            body: JSON.stringify({
              assessmentIds: selectedAssessments.map(
                (item) => item.assessment_hash
              ),
              deploymentId: clientId,
            }),
          }
        );

        const url = await response.json();
        const pdfUrl = await url.reportURL;

        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "GroupReport.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      toast.error("Failed to generate report");
    } finally {
      setDownloading(false);
    }
  };

  const hasSelfAssessmentSelected = (item, selectedMembers, index) => {
    return item?.members?.some(
      (member, subIndex) =>
        member.designation?.includes("Self") &&
        selectedMembers?.includes(`${index + 1}.${subIndex + 1}`)
    );
  };

  const getMembersCompleteCount = (members, index) => {
    return (
      members?.filter((member) => member.status === "complete").length || 0
    );
  };

  const areAllMembersComplete = (members) => {
    if (!members || members.length === 0) {
      return false;
    }
    return members.every((member) => member.status === "complete");
  };

  const handleCheckboxChange = (hash, designation, memebersArr, asmtType) => {
    setSuccessStates({});

    const allSelfHash = assessmentList?.map((el) => {
      if (el?.designation == "360 Assessment" || el?.designation == "Self-Assessment") {
        return el?.assessment_hash;
      }
    })


    const getAllSelfSelected = (selectedMembers) => {
      return selectedMembers.every(item => allSelfHash.includes(item));
    }

    if (hash === "All") {
      setSelectedMembers((prevSelected) => {
        const arraysMatch =
          allSelf.length === prevSelected.length &&
          allSelf.every((item) => prevSelected.includes(item));
        const newSelection = arraysMatch ? [] : allSelf;
        allSelf = newSelection;
        return newSelection;
      });
      setMemebersReport([]);
    }
    else if (asmtType == "360") {
      const membersHash = memebersArr?.map((el) => {
        return el?.assessment_hash;
      });

      const selectedMember = memebersArr?.find(
        (el) => el?.assessment_hash == hash
      );

      setSelectedMembers((prevSelected) => {
        const newSelection = prevSelected.includes(hash)
          ? prevSelected.filter((el) => el !== hash)
          : [...prevSelected, hash];


        const onlySelfChecked = getAllSelfSelected(newSelection)

        let filteredSelection = newSelection.filter((el) =>
          membersHash.includes(el) || onlySelfChecked
        );

        if (onlySelfChecked) {
          filteredSelection = newSelection;
          setMemebersReport([])
        }
        else {
          setMemebersReport(filteredSelection);
        }


        localStorage.setItem("membersReport", JSON.stringify(filteredSelection));
        return filteredSelection;
      });
    }
    else {
      setMemebersReport([]);
      setMemebersSelf();
      setSelectedMembers((prevSelected) => {
        const newSelection = prevSelected.includes(hash)
          ? prevSelected.filter((el) => el !== hash)
          : [...prevSelected, hash];

        const filteredSelection = newSelection.filter((el) => allSelfHash.includes(el));

        return filteredSelection;
      });
    }
  };

  const getLinks = (asmt, additionalAsmt) => {
    const filterLinks = (currentAsmt) =>
      `${asmtLink}/?assessmentId=${currentAsmt?.assessment_hash}`;

    switch (asmt?.designation) {
      case "Self-Assessment":
        return (
          <>
            <div className="assessment-link-container">
              <span
                className="linkclass"
                style={asmt.status === "inactive" ? { filter: "blur(3px)" } : {}}
              >
                {filterLinks(asmt)}
              </span>
              <button
                className="copy-button"
                style={
                  asmt.status === "inactive"
                    ? { backgroundColor: "#CECECE" }
                    : { cursor: "pointer" }
                }
                onClick={
                  asmt.status === "inactive"
                    ? undefined
                    : () => handleCopy(filterLinks(asmt), asmt.status === "inactive")
                }
              >
                <img src={copyicon} alt="" style={{ marginTop: "3px" }} />
              </button>
            </div>
          </>
        );
    }

    switch (additionalAsmt?.designation) {
      case "Self-Assessment":
      case "360 Assessment Direct Report":
      case "360 Assessment Other":
      case "360 Assessment Peer":
      case "360 Assessment Manager":
        return (
          <>
            <span
              className="linkclass"
              style={
                additionalAsmt.status === "inactive"
                  ? { filter: "blur(3px)", background: "#fff" }
                  : { background: "#fff" }
              }
            >
              {filterLinks(additionalAsmt, asmt)}
            </span>
            <button
              className="copy-button"
              style={
                additionalAsmt.status === "inactive"
                  ? { backgroundColor: "#CECECE" }
                  : { cursor: "pointer" }
              }
              onClick={
                additionalAsmt.status === "inactive"
                  ? undefined
                  : () =>
                      handleCopy(
                        filterLinks(additionalAsmt),
                        additionalAsmt.status === "inactive"
                      )
              }
            >
              <img src={copyicon} alt="" style={{ marginTop: "3px" }} />
            </button>
          </>
        );
    }
  };

  const getOverallBadgeText = (asmt) => {
    const done = asmt?.members?.every((el) => el.status === "complete");
    const active = asmt?.members?.every((el) => el.status === "active");
    const pending = asmt?.members?.filter(
      (el) => el.status === "pending" || el.status === "complete"
    );

    if (done) return "Done";
    else if (active) return "Yet to Start";
    else if (pending?.length > 0) return "Ongoing";
    else return "Inactive";
  };

  const getStatusColorText = (asmt, type) => {
    const done = asmt?.members?.every((el) => el.status === "complete");
    const active = asmt?.members?.every((el) => el.status === "active");
    const pending = asmt?.members?.filter(
      (el) => el.status === "pending" || el.status === "complete"
    );

    if (type == "bg") {
      if (done) return "#73b76f";
      else if (active) return "#b6111f";
      else if (pending?.length > 0) return "#eec146";
      else return "#e1e1e1";
    } else {
      if (done) return "#fff";
      else if (active) return "#fff";
      else if (pending?.length > 0) return "#fff";
      else return "#7d7d7d";
    }
  };

  //useeffects
  useEffect(() => {
    if (componentRef.current) {
      setHtmlContent(componentRef.current.innerHTML);
    }
  });

  useEffect(() => {
    callPreviewApi();
  }, [clientId]);

  useEffect(() => {
    const tempReportInfo = previewApiData?.map((el) => {
      const selfInside360 = el?.results?.find(el => el.designation === "360 Assessment")
      if (el?.type == "360") {
        return {
          teamId: el.teamId,
          hash: selfInside360?.hash,
          ...el
        }
      }
      else if (selfInside360?.designation === "360 Assessment" && selfInside360?.type == "Self") {
        return {
          teamId: el.teamId,
          hash: selfInside360?.hash,
          ...el
        }
      }
      else {
        return {
          teamId: el.teamId,
          hash: el?.results?.find(el => el?.designation === "Self-Assessment")?.hash,
          ...el
        }
      }
    })

    setReportInfo(tempReportInfo)
  }, [previewApiData, assessmentList])

  // console.log("previewApiData,assessmentList,reportInfo", previewApiData, assessmentList, reportInfo)



  useEffect(() => {
    const location = window.location.host;
    if (
      process.env.REACT_APP_API_URI?.includes("staging") ||
      location?.includes("d346jgqrzhb1rf")
    ) {
      setAsmtLink("https://d2oe3k18eu8csg.cloudfront.net");
    }
    updateClientData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const popup = document.querySelector(".additional-options-row");
      const activateButton = document.querySelector(".action-button");

      if (popup && !popup.contains(event.target) && !event.target.closest(".action-button")) {
        setActivateButtonStatus(null);
        setAssessmentType(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleActivateClick = (item) => {
    setSuccessStates({});
    if (
      activateButtonStatus === item.assessment_hash &&
      assessmentType === item.designation
    ) {
      setActivateButtonStatus(null);
      setAssessmentType(null);
    } else {
      setActivateButtonStatus(item.assessment_hash);
      setAssessmentType(item.designation);
      setProcessedPayment(false);
    }
  };

  useEffect(() => {
    const handleGlobalClick = (event) => {
      const successMessage = event.target.closest(".available-detail");
      if (!successMessage) {
        setSuccessStates({});
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        setSuccessStates({});
      }
    };

    const handleBeforeUnload = () => {
      setSuccessStates({});
    };

    document.addEventListener("click", handleGlobalClick);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      document.removeEventListener("click", handleGlobalClick);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (searchParams.has("payment_sucess") && !processedPayment) {
      const assessmentId = searchParams.get("payment_sucess");
      const assessmentType = searchParams.get("type");

      setTokenBuyStates((prev) => ({
        ...prev,
        [`${assessmentId}_${assessmentType}`]: false,
        [`${assessmentId}_Self`]: false,
      }));

      setSuccessStates((prev) => ({
        ...prev,
        [`${assessmentId}_${assessmentType}`]: true,
        [`${assessmentId}_Self`]: true,
      }));

      setProcessedPayment(true);

      setTimeout(() => {
        searchParams.delete("payment_sucess");
        searchParams.delete("type");
        setSearchParams(searchParams, { replace: true });
      }, 1000);
    } else if (!processedPayment) {
      const initialTokenBuyStates = {};
      const initialSuccessStates = {};
      assessmentList.forEach((item) => {
        initialTokenBuyStates[
          `${item.assessment_hash}_${item.designation}`
        ] = true;
        initialSuccessStates[`${item.assessment_hash}_${item.designation}`] =
          true;
      });

      setTokenBuyStates(initialTokenBuyStates);
      setSuccessStates(initialSuccessStates);
    }
  }, [searchParams, setSearchParams, assessmentList, processedPayment]);

  return (
    <div className="assessment-list-container">
      {isLoading ? (
        <div className="loader">
          <CircularProgress style={{ color: "#245775" }} size={40} />
        </div>
      ) : (
        <>
          {assessmentList?.length > 0 && (
            <table className="assessment-table">
              <thead>
                <tr className="first-container1">
                  <th style={{ width: "2%" }} className="table-data">
                    <input
                      className="checkbox"
                      type="checkbox"
                      checked={arraysMatch}
                      onChange={() => handleCheckboxChange("All")}
                    />
                  </th>
                  <th style={{ width: "2%" }}>#</th>
                  <th style={{ width: "15%" }}>Name</th>
                  <th style={{ width: "15%" }}>Type</th>
                  <th style={{ width: "30%" }}>Link</th>
                  <th style={{ width: "15%" }}>Status</th>
                  <th style={{ width: "15%" }}>Actions</th>
                  <th style={{ width: "5%" }}></th>
                  <th style={{ width: "5%" }}></th>
                  <th style={{ width: "5%" }}></th>
                  <th style={{ width: "5%" }}></th>
                </tr>
              </thead>
              <tbody>
                {assessmentList?.map((item, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      <td className="table-data">
                        {item?.designation?.includes("Self") &&
                          item.status === "complete" && (
                            <input
                              className="checkbox"
                              type="checkbox"
                              checked={selectedMembers?.includes(item.assessment_hash)}
                              onChange={() =>
                                handleCheckboxChange(item.assessment_hash, item?.designation)
                              }
                            />
                          )}
                      </td>
                      <td className="table-data">{index + 1}.</td>
                      <td
                        className="table-data cursor-detail capitalize"
                        onClick={() => handleMoreDetail(index)}
                        onMouseEnter={() => {
                          setSuccessStates({});
                          setShowEmail(`main-${item.assessment_hash}`);
                        }}
                        onMouseLeave={() => {
                          setShowEmail(``);
                        }}
                      >
                        {showEmail === `main-${item.assessment_hash}` && (
                          <span className="hover-email">{item.email}</span>
                        )}{" "}
                        {item.userName}{" "}
                      </td>
                      <td className="table-data">
                        {item?.designation?.includes("Self") ? (
                          <img src={SelfImage} alt="Self" />
                        ) : (
                          <div
                            className="typeicon"
                            style={{
                              color:
                                item.orgType !== "Self" ? "#BF9540" : "#EAF1F5",
                              backgroundColor:
                                item.orgType !== "Self" ? "#F6DC9B" : "#76A3BE",
                            }}
                          >
                            <img src={refreshmanicon} alt="360" /> 360{" "}
                            {item?.members?.length > 0
                              ? " - " + item?.members?.length
                              : null}
                          </div>
                        )}
                        <span style={{ marginLeft: "5px" }}>
                          {" "}
                          {item.orgType}{" "}
                        </span>
                      </td>
                      <td className="table-data">{getLinks(item)}</td>
                      <td style={{ padding: "8px 0" }}>
                        <div
                          style={{
                            maxWidth: "100px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {item?.designation?.includes("360") ? (
                            <>
                              <span
                                className="status-badge"
                                style={{
                                  background: getStatusColorText(item, "bg"),
                                  color: getStatusColorText(item, "text"),
                                }}
                              >
                                {getOverallBadgeText(item)}
                              </span>
                            </>
                          ) : (
                            <span
                              className="status-badge"
                              style={{
                                color: statusColor[item?.status],
                                backgroundColor:
                                  statusColorMap[item.status] || "#E1E1E1",
                              }}
                            >
                              {statusTextMap[item.status] || "Unknown"}
                            </span>
                          )}
                        </div>
                      </td>
                      <td>
                        {item.designation?.includes("360") ? (
                          areAllMembersComplete(item.members) ? (
                            (() => {
                              const alreadyHas360 = checkReportExist(item.assessment_hash, "360");
                              return (
                                <button
                                  className="action-button"
                                  onClick={async () => {
                                    setSuccessStates({});
                                    if (alreadyHas360) {
                                      const existingReport = reportInfo.find((el) => el.hash == item.assessment_hash && el.type == "360")
                                      let fetchedVariables = await fetchVariables(existingReport?.teamId);
                                      const hashMap = {};
                                      fetchedVariables?.results?.map((el) => {
                                        hashMap[el?.hash] = el?.variables;
                                        return null;
                                      });
                                      setGroupMembersHashMap({
                                        teamId: existingReport?.teamId,
                                        hashMap,
                                      });
                                      setSelectedReport({
                                        assessment_hash: existingReport.teamId,
                                        id: item.assessment_hash,
                                        name: item.teamname,
                                        teamId: existingReport.teamId,
                                        remark: ["Group Members", item?.members?.map(member => member.userName.trim()).join(", ")],
                                        reportName: existingReport.teamname,
                                        reportType: "360",
                                        self_hash: item.assessment_hash,
                                        teamName: existingReport.teamname,
                                        createdDate: existingReport?.createdDate,
                                        _originalData: existingReport
                                      })
                                      setOpenReport(false)
                                      // navigate(
                                      //   `/client/${clientId}?tab=reports&assessmentId=${item.assessment_hash}&reportType=360`
                                      // );
                                      setValue && setValue(2);
                                      return;
                                    }
                                    const selfAssessment = {
                                      userName: item.userName,
                                      assessment_hash: item.assessment_hash,
                                    };
                                    const base = `${
                                      selfAssessment.userName
                                    }`;
                                    const filename = nextUniqueNameFor360(base);
                                    await generate360Report(
                                      selfAssessment,
                                      filename
                                    );
                                    await callPreviewApi();
                                  }}
                                  disabled={hasSelfAssessmentSelected(item, selectedMembers, index) || is360ReportGenerating}
                                  style={{
                                    opacity: hasSelfAssessmentSelected(item, selectedMembers, index) || is360ReportGenerating ? "0.5" : "1",
                                    cursor: hasSelfAssessmentSelected(item, selectedMembers, index) || is360ReportGenerating ? "not-allowed" : "pointer",
                                  }}
                                >
                                  {alreadyHas360 ? "View Report" : is360ReportGenerating ? "Generating..." : "Generate Report"}
                                </button>
                              );
                            })()
                          ) : item.status === "inactive" ? (
                            <button
                              className="action-button"
                              onClick={() => handleActivateClick(item)}
                            >
                              Activate
                            </button>
                          ) : (
                            <div className="tooltip-container">
                              <button className="action-button disabled-button">
                                Generate Report
                              </button>
                              <span className="tooltip">
                                Complete the assessment first
                              </span>
                            </div>
                          )
                        ) : item.status === "complete" ? (
                          (() => {
                            const alreadyHasSelf = checkReportExist(item.assessment_hash, "self");
                            return (
                              <button
                                className={`action-button`}
                                onClick={async () => {
                                  setSuccessStates({});
                                  const alreadyHasSelf = checkReportExist(item.assessment_hash, "self");
                                  const existingReport = reportInfo.find((el) => el.results?.[0]?.hash == item.assessment_hash && el.type == "self")

                                  if (alreadyHasSelf) {
                                    let fetchedVariables = await fetchVariables(existingReport?.teamId);
                                    const hashMap = {};
                                    fetchedVariables?.results?.forEach((el) => {
                                      hashMap[el?.hash] = el?.variables;
                                    });
                                    setGroupMembersHashMap({
                                      teamId: existingReport?.teamId,
                                      hashMap,
                                    });
                                    setSelectedReport({
                                      assessment_hash: existingReport.teamId,
                                      id: item.assessment_hash,
                                      name: item.teamname,
                                      teamId: existingReport.teamId,
                                      remark: [],
                                      reportName: existingReport.teamname,
                                      reportType: "self",
                                      self_hash: item.assessment_hash,
                                      teamName: existingReport.teamname,
                                      createdDate: existingReport?.createdDate,
                                      _originalData: existingReport,
                                    });
                                    setOpenReport(false);
                                  } else {
                                    // Generate new self report
                                    await createSelfReport(item, item?.userName);
                                  }
                                  setValue && setValue(2);
                                }}
                                disabled={
                                  hasSelfAssessmentSelected(item, selectedMembers, index) ||
                                  isGeneratingSelfReport?.[item.assessment_hash]
                                }
                                style={{
                                  opacity: hasSelfAssessmentSelected(item, selectedMembers, index) || isGeneratingSelfReport?.[item.assessment_hash] ? "0.5" : "1",
                                  cursor: hasSelfAssessmentSelected(item, selectedMembers, index) || isGeneratingSelfReport?.[item.assessment_hash] ? "not-allowed" : "pointer",
                                }}
                              >
                                {alreadyHasSelf ? "View Report" : isGeneratingSelfReport?.[item.assessment_hash] ? "Generating..." : "Generate Report"}
                              </button>
                            );
                          })()
                        ) : item.status === "inactive" ? (
                          <button
                            className="action-button"
                            onClick={() => handleActivateClick(item)}
                          >
                            Activate
                          </button>
                        ) : (
                          <div className="tooltip-container">
                            <button className="action-button disabled-button">
                              View Report
                            </button>
                            <span className="tooltip">
                              Complete the assessment first
                            </span>
                          </div>
                        )}
                      </td>
                      {item && item?.designation.includes("Self") ? <td></td> : null}
                      <td>
                        <span className="delete-badge">
                          <button className="ctr-badge">
                            {item &&
                              item?.members &&
                              item?.members?.length > 0 &&
                              item?.designation?.includes("360") ? (
                              <img
                                src={moreoptionicon}
                                alt="more option"
                                onClick={() => handleMoreOptionsToggle(index)}
                                style={{
                                  transition: "transform 0.3s",
                                  transform: showMoreOptions[index]
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                  padding: "12px 0",
                                }}
                              ></img>
                            ) : (
                              <img
                                src={deleteicon}
                                alt="delete icon"
                                onClick={() =>
                                  handleOpenModal(item.assessment_hash)
                                }
                              />
                            )}
                          </button>
                        </span>
                      </td>
                      {item &&
                        item?.members &&
                        item?.members?.length > 0 &&
                        item?.designation?.includes("360") ? (
                        <td>
                          <span className="delete-badge">
                            <button className="ctr-badge">
                              <img
                                src={deleteicon}
                                alt="delete icon"
                                onClick={() =>
                                  handleOpenModal(item.assessment_hash)
                                }
                              />
                            </button>
                          </span>
                        </td>
                      ) : null}
                      <td>
                        <span
                          className="edit-icon"
                          onClick={() => {
                            setSuccessStates({});
                            setEditForm(item);
                          }}
                        >
                          <img src={EditIcon} alt="" />
                        </span>
                      </td>
                    </tr>

                    {/* more Detail*/}
                    {item.assessment_hash === activateButtonStatus &&
                      item.designation === assessmentType &&
                      (item?.status === "inactive" ||
                        successStates[
                        `${item.assessment_hash}_${item.designation}`
                        ]) && (
                        <tr className="additional-options-row">
                          <td colSpan={11} className="more-data">
                            <div className="more-data-container">
                              {item?.status === "inactive" ? (
                                <>
                                  <p className="token">
                                    Tokens Required:{" "}
                                    <span
                                      className="available"
                                      style={{ margin: "0px" }}
                                    >
                                      {" "}
                                      {item?.designation?.includes("Self")
                                        ? "2"
                                        : "4"}{" "}
                                      tokens{" "}
                                    </span>{" "}
                                  </p>
                                  <div className="available-detail">
                                    <div>
                                      <p className="available">
                                        {" "}
                                        Available immediately{" "}
                                      </p>
                                      <p className="subtext">
                                        {" "}
                                        You have {tokenCtx.selectedToken} tokens{" "}
                                      </p>
                                    </div>
                                    <button
                                      className="cta-token"
                                      disabled={purchasingAssessmentHash !== null}
                                      onClick={() =>
                                        handleTokenPurchase(
                                          item.assessment_hash,
                                          item?.designation,
                                          item
                                        )
                                      }
                                    >
                                      {purchasingAssessmentHash === item.assessment_hash ? (
                                        <CircularProgress
                                          style={{ color: "#fff" }}
                                          size={20}
                                        />
                                      ) : (
                                        `Use ${item?.designation?.includes("Self")
                                          ? 2
                                          : 4
                                        } Tokens`
                                      )}
                                    </button>
                                  </div>
                                </>
                              ) : (
                                successStates[
                                `${item.assessment_hash}_${item.designation}`
                                ] && (
                                  <>
                                    <img
                                      src={successicon}
                                      alt="successicon"
                                      className="successicon"
                                    />
                                    <div className="available-detail">
                                      <div>
                                        <p className="success">Success!</p>
                                        <p className="subtext-success">
                                          You have successfully purchased a{" "}
                                          {item.designation?.includes("Self")
                                            ? "Self-Assessment"
                                            : "360 Assessment"}{" "}
                                          using{" "}
                                          {item?.designation?.includes("Self")
                                            ? "2"
                                            : "4"}{" "}
                                          tokens
                                        </p>
                                      </div>
                                      {item.designation?.includes("Self") && (
                                        <div className="assessment-link-container">
                                          <span className="linkclass">
                                            `${asmtLink}/?assessmentId=${item.assessment_hash}`
                                          </span>
                                          <button
                                            className="copy-button"
                                            onClick={() =>
                                              handleCopy(
                                                `${asmtLink}/?assessmentId=${item.assessment_hash}`,
                                                false
                                              )
                                            }
                                          >
                                            Copy
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </>
                                )
                              )}
                            </div>
                          </td>
                        </tr>
                      )}

                    {/* Render additional items if the more options are toggled */}
                    {showMoreOptions[index] &&
                      item?.members?.map((additionalItem, subIndex) => (
                        <tr
                          key={`${index}-${subIndex}`}
                          style={{ background: "#f1f3f3" }}
                        >
                          <td className="table-data">
                            {additionalItem?.status?.toLowerCase() === "complete" && (
                              <input
                                className="checkbox"
                                type="checkbox"
                                checked={selectedMembers?.includes(additionalItem.assessment_hash)}
                                onChange={() => {
                                  setMemebersSelf(item); handleCheckboxChange(additionalItem.assessment_hash, additionalItem?.designation, item?.members, "360");
                                }}
                                style={{
                                  backgroundColor: selectedMembers?.includes(additionalItem.assessment_hash)
                                    ? "#76A3BE"
                                    : "#ffffff",
                                }}
                              />
                            )}
                          </td>
                          <td className="table-data">
                            {`${index + 1}.${subIndex + 1}`}.
                          </td>
                          <td
                            className="table-data"
                            onMouseEnter={() => {
                              setSuccessStates({});
                              setShowEmail(additionalItem.assessment_hash);
                            }}
                            onMouseLeave={() => {
                              setShowEmail(``);
                            }}
                          >
                            {showEmail === additionalItem.assessment_hash && (
                              <span className="hover-email">
                                {additionalItem.email}
                              </span>
                            )}
                            {additionalItem.userName}
                          </td>
                          <td className="table-data">
                            {item?.designation?.includes("Self") ? (
                              <img src={SelfImage} alt="Self" />
                            ) : (
                              <div
                                className="typeicon"
                                style={
                                  additionalItem?.designation?.includes("Self")
                                    ? { backgroundColor: "transparent" }
                                    : {
                                      color:
                                        item.orgType !== "Self"
                                          ? "#BF9540"
                                          : "#EAF1F5",
                                      backgroundColor:
                                        item.orgType !== "Self"
                                          ? "#F6DC9B"
                                          : "#76A3BE",
                                    }
                                }
                              >
                                {additionalItem?.designation ===
                                  "Self-Assessment" ? (
                                  <>
                                    <img src={SelfImage} alt="Self" />
                                  </>
                                ) : (
                                  <>
                                    <img src={refreshmanicon} alt="360" /> 360 :
                                    {additionalItem?.designation
                                      ? additionalItem?.designation?.replace(
                                        /^360 Assessment /,
                                        ""
                                      )
                                      : ""}{" "}
                                  </>
                                )}
                              </div>
                            )}
                            <span style={{ marginLeft: "5px" }}>
                              {" "}
                              {item.orgType}{" "}
                            </span>
                          </td>
                          <td className="table-data">
                            <div className="assessment-link-container">
                              {getLinks(item, additionalItem)}
                            </div>
                          </td>
                          <td style={{ padding: "8px 0" }}>
                            <div
                              style={{
                                maxWidth: "100px",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <span
                                className="status-badge"
                                style={{
                                  color: statusColor[additionalItem?.status],
                                  backgroundColor:
                                    statusColorMap[additionalItem.status] ||
                                    "#E1E1E1",
                                }}
                              >
                                {" "}
                                {statusTextMap[additionalItem.status] ||
                                  "Unknown"}{" "}
                              </span>
                            </div>
                          </td>
                          <td>
                            <>
                              {additionalItem.designation?.includes("Self") && (
                                <td style={{ padding: "0px" }}>
                                  {checkReportExist(item.assessment_hash, "self") ? (
                                    <button
                                      className="action-button"
                                      onClick={async () => {
                                        setSuccessStates({});
                                        const alreadyHasSelf = checkReportExist(item.assessment_hash, "self");
                                        const existingReport = reportInfo.find((el) => el.results?.[0]?.hash == item.assessment_hash && el.type == "self")

                                        if (alreadyHasSelf) {
                                          let fetchedVariables = await fetchVariables(existingReport?.teamId);
                                          const hashMap = {};
                                          fetchedVariables?.results?.forEach((el) => {
                                            hashMap[el?.hash] = el?.variables;
                                          });
                                          setGroupMembersHashMap({
                                            teamId: existingReport?.teamId,
                                            hashMap,
                                          });
                                          setSelectedReport({
                                            assessment_hash: existingReport.teamId,
                                            id: item.assessment_hash,
                                            name: item.teamname,
                                            teamId: existingReport.teamId,
                                            remark: [],
                                            reportName: existingReport.teamname,
                                            reportType: "self",
                                            self_hash: item.assessment_hash,
                                            teamName: existingReport.teamname,
                                            createdDate: existingReport?.createdDate,
                                            _originalData: existingReport,
                                          });
                                          setOpenReport(false);
                                        }
                                        setValue && setValue(2);
                                      }}
                                    >
                                      View Report
                                    </button>
                                  ) : (additionalItem?.status === "complete") ? (
                                    isGeneratingReport ?
                                      <button className="action-button disabled-button" >
                                        <CircularProgress size={20} />
                                      </button>
                                      :
                                      <button
                                        className="action-button"
                                        onClick={() => createSelfReport(additionalItem, additionalItem?.userName)}
                                      >
                                        Generate Report
                                      </button>
                                  ) : (
                                    <div className="tooltip-container">
                                      <button className="action-button disabled-button">
                                        Generate Report
                                      </button>
                                      <span className="tooltip">Complete the assessment first</span>
                                    </div>
                                  )}
                                </td>
                              )}
                            </>
                          </td>
                          <td></td>
                          <td>
                            {!additionalItem.designation?.includes("Self") && (
                              <span className="delete-badge">
                                <button className="ctr-badge">
                                  <img src={deleteicon} alt="delete icon" onClick={() => handleOpenModal(additionalItem.assessment_hash)} />
                                </button>
                              </span>
                            )}
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))}
                {selectedMembers.length > 1 && memebersReport?.length == 0 && (
                  <tr style={{ background: "#f1f3f3" }}>
                    <td className="generate-group-report-cell-data" colSpan="100%">
                      <div className="generate-group-report-container team-name-group-report-row">
                        <div className="team-name-form-group">
                          <label className="team-name-label">Team Name</label>
                          <input
                            type="text"
                            className="team-name-input capitalize"
                            placeholder="Type your team's name"
                            value={teamName}
                            onChange={(e) => {
                              setSuccessStates({});
                              setTeamName(e.target.value);
                              setTeamNameError("");
                              setTeamNameExists(false);
                              setIsAutoGeneratedName(false);
                            }}
                            disabled={isValidatingTeamName}
                          />
                          {teamNameError && (
                            <div className="team-name-error">{teamNameError}</div>
                          )}
                          {isValidatingTeamName && (
                            <div className="team-name-validating">
                              Validating team name...
                            </div>
                          )}
                          <div className="team-name-helper">
                            <img src={infoIcon} alt="info" className="team-name-helper-icon" style={{ width: "16px", height: "16px", marginRight: "6px", verticalAlign: "middle", }} />
                            Please enter the team name to be displayed in the
                            Group Report.
                          </div>
                        </div>
                        <div className="cta-ggr">
                          <p> {" "} Tokens Required: <span>4 tokens</span>{" "} </p>
                          <Button
                            className="bta-cta-ggr"
                            onClick={() => { setSuccessStates({}); handleGenerateGroupReport(); }}
                            disabled={teamNameExists || isValidatingTeamName || isGeneratingGroupReport || tokenCtx.selectedToken < 4 }
                          >
                            {isGeneratingGroupReport ? (
                              <>
                                <CircularProgress style={{ color: "#fff", marginRight: "8px" }} size={16} />
                                Generating...
                              </>
                            ) : (
                              "Generate Group Report"
                            )}
                          </Button>
                        </div>
                      </div>
                      {tokenCtx.selectedToken < 4 && (
                        <div className="tokenlessthethree">
                          <div className="left">
                            <p className="firsttext">
                              Tokens Required:{" "}
                              <span className="secoundtext">4 tokens</span>
                            </p>
                            <p className="secoundtext">Insufficient tokens</p>
                            <p className="thirdtext">
                              You have{" "}
                              {tokenCtx.selectedToken === null ||
                                tokenCtx.selectedToken === undefined
                                ? "Loading..."
                                : tokenCtx.selectedToken}{" "}
                              token
                            </p>
                          </div>
                          <div className="right">
                            <Button className="bta-cta-ggr" onClick={() => {
                              setSuccessStates({}); navigate("/tokens", {
                                state: { requiredTokens: 4 },
                              })
                            }} >
                              Buy 4 Tokens
                            </Button>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
          {/* Observer Count Validation Modal */}
          <Modal open={showObserverCountModal} onClose={() => setShowObserverCountModal(false)} className="custom-modal" >
            <div className="modal-content">
              <div style={{ textAlign: "right" }}>
                <button
                  onClick={() => setShowObserverCountModal(false)}
                  style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", padding: "10px", position: "absolute", right: "10px", top: "5px", color: "#394554", fontWeight: "bold", }}
                >
                  ×
                </button>
              </div>
              <div style={{ textAlign: "center" }}>
                <h3 className="modal-text" style={{ marginBottom: "15px" }}>
                  Minimum Observers Required
                </h3>
                <p style={{ fontFamily: "Lato, sans-serif", fontWeight: 700, fontSize: "21px", lineHeight: "25.2px", letterSpacing: "0px", textAlign: "center", color: "#666", }} >
                  A 360 Report requires at least 3 observers. Please add more to
                  proceed.
                </p>
                <div className="modal-actions">
                  <button
                    onClick={() => setShowObserverCountModal(false)}
                    className="modal-button cancel-button"
                    style={{ backgroundColor: "#426B88", color: "white", border: "none", boxShadow: "0px 3px 0px 0px #245775", fontFamily: "Lato", fontWeight: 700, lineHeight: "100%", letterSpacing: "0px", textAlign: "center", textTransform: "none", fontSize: "21px", height: "45px", width: "121px", borderRadius: "5px", cursor: "pointer", }}
                  >
                    {" "}
                    Close{" "}
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          <Modal open={showSelfAssessmentAlert} onClose={() => setShowSelfAssessmentAlert(false)} className="custom-modal" >
            <div className="modal-content">
              <div style={{ textAlign: "right" }}>
                <button
                  onClick={() => setShowSelfAssessmentAlert(false)}
                  style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", padding: "10px", position: "absolute", right: "10px", top: "5px", color: "#394554", fontWeight: "bold", }}
                >
                  {" "}
                  ×{" "}
                </button>
              </div>
              <div style={{ textAlign: "center" }}>
                <h3 className="modal-text" style={{ marginBottom: "15px" }}>
                  Alert
                </h3>
                <p style={{ fontFamily: "Lato, sans-serif", fontWeight: 700, fontSize: "21px", lineHeight: "25.2px", letterSpacing: "0px", textAlign: "center", color: "#666", }} >
                  {asmtAlertText}
                </p>
                <div className="modal-actions">
                  <button
                    onClick={() => setShowSelfAssessmentAlert(false)}
                    className="modal-button cancel-button"
                    style={{ backgroundColor: "#426B88", color: "white", border: "none", boxShadow: "0px 3px 0px 0px #245775", fontFamily: "Lato", fontWeight: 700, lineHeight: "100%", letterSpacing: "0px", textAlign: "center", textTransform: "none", fontSize: "21px", height: "45px", width: "121px", borderRadius: "5px", cursor: "pointer", }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          <Modal open={openModal} onClose={handleCloseModal} className="custom-modal">
            <div className="modal-content">
              <div>
                <img src={deleteIcon} alt="delete icon" className="modal-icon" />
                <p className="modal-text">
                  {" "}
                  Are you sure you want to permanently<br></br>delete this
                  assessment?{" "}
                </p>
                <div className="modal-actions">
                  <Button
                    variant="contained"
                    className="modal-button cancel-button"
                    onClick={handleCloseModal}
                  >
                    {" "}
                    No, Cancel{" "}
                  </Button>
                  <Button
                    variant="outlined"
                    className="modal-button delete-button"
                    onClick={handleConfirmDelete}
                  >
                    {" "}
                    Yes, Delete{" "}
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        </>
      )}
    </div>
  );
}
